import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'myDateEcwid',
})
export class DateEcwidPipe implements PipeTransform {
  /**
   * Takes a string and returns a moment date value
   * @param value: string
   * @param format: string
   */
  transform(value: string, format: string) {

    // let date = moment(value, moment.ISO_8601, true); // Intenta parsear como ISO 8601 en modo estricto

    // if (!date.isValid()) {
    //   date = moment(value); // Si no es válido, intenta parsear sin formato específico
    // }
    let sDate = value.split(' ');
    console.log('sDate: ', sDate[0]);
    console.log('sDate 1: ', sDate[1]);

    const dateTime = `${sDate[0]} ${sDate[1]}`;
    
    // Parse la cadena combinada usando Moment.js
    let dateMoment = moment(dateTime, moment.ISO_8601, true);
    
    if (!dateMoment.isValid()) {
      dateMoment = moment(dateTime); // Intenta parsear sin formato específico si el primer intento falla
    }
    
    return dateMoment.isValid() ? dateMoment.format(format) : 'Invalid date';


    //return value;// date.isValid() ? date.format(format) : 'Invalid date';

    //return moment(value).format(format);
  }
}
